import { parseISO, format } from 'date-fns';
import { CrawlerDetail } from 'types/crawlerDetail';

export type PastCrawlerDetail = Pick<
  CrawlerDetail,
  'version' | 'description' | 'configTemplate' | 'releasedAt'
> & {
  adhocSupportedIntervals: string;
  releasedChannels: string;
};

export const mapCrawlerDetailToPastCrawlerDetail = ({
  version,
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  stable,
  beta,
}: CrawlerDetail): PastCrawlerDetail => {
  const adhocSupportedIntervalStrs = adhocSupportedIntervals.map((value) => {
    if (value === 'none') {
      return '手動実行のみ';
    }

    return value;
  });

  const releasedChannels = [];
  if (stable) {
    releasedChannels.push('安定版');
  }
  if (beta) {
    releasedChannels.push('ベータ版');
  }

  return {
    version,
    description,
    releasedAt: format(parseISO(releasedAt), 'yyyy-MM-dd'),
    configTemplate,
    adhocSupportedIntervals: adhocSupportedIntervalStrs.join(' / '),
    releasedChannels: releasedChannels.join(' / '),
  };
};
